// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-view__extended[data-v-aa62b5fa] .dot {\n  width: 34px;\n  height: 34px;\n}", ""]);
// Exports
module.exports = exports;
